module.exports = __webpack_public_path__ + "static/media/cooling-stering-flush-and-fill-red.913468d4.svg";